export default __webpack_public_path__ + "static/media/seminar (1).6e4c2497.JPG";